<template>
  <div>
    <Modal v-bind="$attrs" v-on="$listeners" @closed="closed">
      <template #action>
        <div class="main">
          <!-- 承認申請しない -->
          <PrimaryButton text="承認申請しない" size="normal bg-indigo-200 text-indigo-700 hover:bg-indigo-300 m-3" @click="register('notApproval')" />

          <div v-if="priceChange" class="text-gray-800">
            単価が変更、もしくは調整費が入力されています。<br>
            承認申請をする場合は、設定を確認してください。
          </div>

          <!-- 承認フロー -->
          <div>
            <div v-if="dep" class="mx-auto w-fit mt-5">
              <input
                type="checkbox"
                id="isMyList"
                v-model="isMyList"
              >
              <label for="isMyList" class="ml-1" :class="isMyList?'text-blue-700 font-bold':'text-gray-700'"> {{ dep }} の承認ルートのみ表示 </label>
            </div>

            <!-- 承認 ルート名 -->
            <div class="mt-3 mb-8 w-fit mx-auto">
              <div class="text-sm text-gray-700 mb-1">ルート名</div>
              <select
                name="route"
                v-model="estimate.approvalInfo.route"
                class="focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 font-bold rounded"
                @change="getApproverList()"
              >
                <option
                  v-for="value in route" :key='value.id'
                  :value="value.routeName">
                  {{ value.routeName }}
                </option>
              </select>
            </div>

            <div class="flex justify-center" v-if="estimate.approvalInfo.route!=''">
              <div class="w-80 m-2">
                <div class="text-sm text-gray-700 text-center p-3 bg-pink-100">承認者1</div>
                <div v-for="(flow1, index) in approverList1" :key="index">
                  <div class="text-center p-3 text-sm font-medium text-gray-700 tracking-wider border border-gray-300 w-full">
                    {{flow1.userName}}
                  </div>
                </div>
                <div class="text-sm text-gray-500 p-3 text-center" v-if="!approverList1.length">1番目の承認者は設定されていません</div>
                <!-- チャット送信設定 -->
                <div class="my-6" v-else>
                  <input
                    type="checkbox"
                    id="chatwork1"
                    v-model="estimate.approvalInfo.chatwork1"
                  >
                  <label for="chatwork1" class="text-gray-700 ml-1"> 承認者1にチャットを送る </label>
                </div>

                <!-- 承認者1へのメモ -->
                <div v-if="estimate.approvalInfo.chatwork1">
                  <span class="text-sm text-gray-700">承認者1へのメッセージ</span>
                  <textarea
                    type="text"
                    name="memo"
                    rows="6"
                    class="py-1 text-sm border-gray-300 rounded w-full mt-3"
                    v-model="estimate.approvalInfo.message1"
                  />
                </div>
              </div>

              <div class="w-80 m-2">
                <div class="text-sm text-gray-700 text-center p-3 bg-pink-100">承認者2</div>
                <div v-for="(flow2, index) in approverList2" :key="'2' + index">
                  <div class="text-center p-3 text-sm font-medium text-gray-700 tracking-wider border border-gray-300 w-full">
                    {{flow2.userName}}
                  </div>
                </div>
                <div class="text-xs text-gray-500 p-3 text-center" v-if="!approverList2.length">2番目の承認者は設定されていません</div>
                <!-- チャット送信設定 -->
                <div class="my-6" v-else>
                  <input
                    type="checkbox"
                    id="chatwork2"
                    v-model="estimate.approvalInfo.chatwork2"
                  >
                  <label for="chatwork2" class="text-gray-700 ml-1"> 承認者2にチャットを送る </label>
                </div>

                <!-- 承認者1へのメモ -->
                <div v-if="estimate.approvalInfo.chatwork2">
                  <span class="text-sm text-gray-700">承認者2へのメッセージ<br>*承認者1が全員承認した後にチャットが送られます*</span>
                  <textarea
                    type="text"
                    name="memo"
                    rows="6"
                    class="py-1 text-xs border-gray-300 rounded w-full mt-3"
                    v-model="estimate.approvalInfo.message2"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- 承認申請する -->
          <div class="mt-10 mx-3 mb-3">
            <PrimaryButton text="承認申請する" size="normal w-full m-3 " @click="register('doApproval')" />
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>

import Modal from '@components/Modal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import * as estimateManager from '@managers/estimateManager'
import * as utils from '@libs/utils'

export default {
  components: {
    Modal,
    PrimaryButton,
  },

  props: {
    priceChange: {
      type: Boolean
    },
    open: {
      type: Boolean
    },
    estimate: {
      type: Object
    },
    routeName: {
      type: String
    }
  },

  data() {
    return {
      // departmentsList: {},
      // 承認者1リスト
      approverList1: [],
      // 承認者2リスト
      approverList2: [],
      // ルートリスト
      route: [],
      // 承認マスターデータ
      approverMst: [],
      // 選択したルートデータ
      routeData: '',
      // 自分の部署のみに関わる承認ルートのみ表示
      isMyList: true
    }
  },

  created() {
    this.getDepartmentsList()
  },

  computed: {
    /**
     * メイン所属部署のID
     */
    depId() {
      return this.$store.getters.loginUserData.departmentIdUser
    },

    /**
     * メイン所属部署名
     */
    dep() {
      return this.$store.getters.loginUserData.departmentName
    }
  },

  watch: {
    'open': {
      handler: function() {
        if (this.open) {
          // 承認者取得
          this.getApproverList()
        }
      }
    },

    'isMyList': {
      handler: function() {
        if (this.open) {
          // 承認ルートリスト変更
          this.getRouteList()
        }
      }
    }
  },

  methods: {
    /**
     * 部署名リスト,承認者候補リストを取得
     */
    async getDepartmentsList() {

      // 承認マスタからデータを取得
      this.approverMst = await estimateManager.getApprover(this)
      // ルート名リスト取得
      this.getRouteList()
    },

    /**
     * ルート名取得
     */
    getRouteList() {
      if (this.isMyList && this.dep) {
        let res = []
        res = this.approverMst.filter((row) => {
          return (!row.departments || !row.departments.length || ('').includes(row.departments) || (this.depId && row.departments.includes(this.depId)))
        })
        if (res && res.length) {
          this.route = res
        } else {
          this.route = utils.clone(this.approverMst)
        }

      } else {
        this.route = utils.clone(this.approverMst)
      }
    },

    /**
     * 承認者候補リスト取得
     */
    getApproverList() {
      let info = this.estimate.approvalInfo

      // ルート名が空文字でない場合
      if (info.route != '') {

        // 承認マスタからルート名が合致するデータを取得
        let list = this.approverMst.find((u) => {
          if (info.route == u.routeName) {
          return true
          }
        })

        if (list) {
          // 承認者1データ取得
          if (list.approver1 && list.approver1.length) {
            this.approverList1 = list.approver1
          } else {
            this.approverList1 = []
          }

          // 承認者2データ取得
          if (list.approver2 && list.approver2.length) {
            this.approverList2 = list.approver2
          } else {
            this.approverList2 = []
          }

          // ルートデータ
          this.routeData = list
        }
      }
    },

    closed() {
      console.log('EstimateApprovalModal::closed')
    },

    /**
     * 登録処理（申請しないボタン、申請するボタン クリックイベント）
     * @param btn ボタン名
     */
    async register(btn) {

      // 申請しないボタン押下時、承認ルートを空にする
      if (btn == 'notApproval') {
        this.estimate.approvalFlow1 = []
        this.estimate.approvalFlow2 = []
        this.$emit('notApproval', false)

      // 申請するボタン押下時、承認ルートの確認＆形成
      } else {

        let flow1 = this.approverList1.map((a) => {
          return {sequentialOrder: '1', userId: a.userId, userName: a.userName, chatworkAccountId: a.chatworkAccountId, chatworkRoomId: a.chatworkRoomId, chatworkApiToken: a.chatworkApiToken, status: '未承認'}
        })

        this.estimate.approvalFlow1 = flow1

        let flow2 = this.approverList2.map((a) => {
          return {sequentialOrder: '2', userId: a.userId, userName: a.userName, chatworkAccountId: a.chatworkAccountId, chatworkRoomId: a.chatworkRoomId, chatworkApiToken: a.chatworkApiToken, status: '未承認'}
        })

        this.estimate.approvalFlow2 = flow2

        // 承認者2へチャットワーク送信がONになり、かつメッセージが入っている場合は、見積作成者の名前を付ける
        if (this.estimate.approvalInfo.chatwork2 && this.estimate.approvalInfo.message2 != '') {
          this.estimate.approvalInfo.message2 = this.estimate.approvalInfo.message2 + '\n' + '* 見積り作成者： ' + this.$store.getters.user.user_name + ' *\n' + '----------------------------------'
        }
        this.$emit('doApproval', this.routeData)
      }
    }
  }
}
</script>
<style scoped>
.main {
  min-width: 800px;
}
</style>